export const LEFT_NAVIGATION_ENABLED_COOKIE_NAME = 'leftNavigationEnabled';
export const MAX_NAVIGATION_WIDTH = '204px';
export const MIN_NAVIGATION_WIDTH = '80px';
export const MIN_NAVIGATION_HEIGHT = '64px';
